import React, { useState, useEffect, useRef } from 'react';
import Chart from "react-apexcharts";

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import { copyToClipboard, fixDate } from '../../helpers/helperFunctions';
import ExtendedInfoGraph from '../Graphs/ExtendedInfoGraph';
import AlarmCentralModal from './AlarmCentralModal';
import NewButton from '../Buttons/NewButton';
import { useNavigate } from "react-router-dom";


const ExtendedInfoModal = ({show, type, data, onClose, turnOffStolenMode}) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [info, setInfo] = useState({title: "battery_title", copy: "battery_copy", icon: "battery_full"})
    const [visibleInfo, setVisibleInfo] = useState({})
    const [modalType, setModalType] = useState()
    const [graphInfo, setGraphInfo] = useState([])
    const [copySuccess, setCopySuccess] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        typeRender()
    }, [type])

    useEffect(() => {
        if(data?.data){
            const lastPoint = data?.data[data?.data?.length-1]
            setGraphInfo({points: data?.data, unit: data?.unit})
            setVisibleInfo(lastPoint)
        }
    }, [data])

    const clicky = (clickedData) => {
        if(clickedData?.servertime){
            setVisibleInfo(clickedData)

        }
    }

    const goTo = (page) => {
		navigate(`/${page}`, /* {state: {deviceid: device?.id}} */)
	};

    const handleClose = () => {
        setModalType(null)
        setGraphInfo([])
        onClose()
    }

    const copyLink = (url) => {
        copyToClipboard(url).then((result) => {
            setCopySuccess(true)
            setTimeout(() => {
                setCopySuccess(false)
            }, 1000);
		})
		.catch((error) => {
			console.error("Copy failed:", error); // trigger failure action
		});
    }

    const graphModal = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t(`extended_info.${info.title}`)}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
                </div>
                <div className="d-flex flex-column">
                    <p className="grey-blue py-3">{t(`extended_info.${info.copy}`)}</p>
                    <div className="d-flex justify-content-around align-items-center">
                        {data?.data?.length === 0
                            ?
                            <>
                            <p className="thin dark-grey">{t("extended_info.no_history")}</p>
                            </>
                            :
                            <>
                            <div className="detail_container bg-light-grey d-flex flex-column border-12 p-3 align-items-center w-50 me-2">
                                <p className="bold">{fixDate(visibleInfo?.servertime, true)}</p>
                            </div>
                            <div className="detail_container bg-light-grey d-flex flex-row border-12 p-3 align-items-center w-50 justify-content-around ms-2">                    
                                    {type === "temp" || type === "humidity" ?
                                        <>
                                            <p className="bold">
                                                H: {visibleInfo?.value_highest != null ? (visibleInfo?.value_highest).toFixed(1) : "--"}{graphInfo?.unit ?? "%"}
                                            </p>
                                            <p className="bold">
                                                L: {visibleInfo?.value_lowest != null ? (visibleInfo?.value_lowest).toFixed(1) : "--"}{graphInfo?.unit ?? "%"}
                                            </p>
                                        </>
                                        : type === "battery"
                                        ?
                                        <p className="bold">{(visibleInfo?.value)?.toFixed(1)}{graphInfo?.unit ?? "%"}</p>
                                        :
                                        <p className="bold">{((visibleInfo?.value))?.toFixed(2)}{graphInfo?.unit ?? "%"}</p>
                                    }

                            </div>
                            </>
                        }
                        
                    </div>
                    <ExtendedInfoGraph type={type} data={graphInfo} setClickedData={(clickedData) => clicky(clickedData)} />
                </div>

            </div>
        )
    }

    const dataplanModal = () => {
        const subscription = data?.device?.dataplan
        const active_plan = subscription?.dataplan_active
        const no_recurring = subscription?.dataplan_status === "ending" || subscription?.dataplan_status === "failed"
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t(`extended_info.${info.title}`)}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
                </div>
                <div className="d-flex flex-column">
                    <p className="grey-blue py-3">{t(`extended_info.${info.copy}`)}</p>
                    <div className="d-flex flex-column justify-content-around align-items-center">

                        <div className="d-flex bg-light-grey border-12 w-100 p-3 justify-content-center">
                            <div className="d-flex flex-column align-items-center">
                                <p className="bold">{!active_plan ? t("extended_info.no_dataplan"): subscription?.dataplan?.plan_name}</p>
                                <p className="dark-grey">{t("extended_info.current_dataplan")}</p>
                            </div>
                            {subscription?.dataplan?.has_scheduled_change &&
                            <>
                                <img src={icons.chevron_right} className="grey-blue-icon mx-3" alt="" />
                                <div className="d-flex flex-column align-items-center">
                                    <p className="bold">{subscription?.dataplan?.plan_name}</p>
                                    <p className="dark-grey">{t("extended_info.pending_dataplan")}</p>
                                </div>
                            </>
                            }
                        </div>
                        {!active_plan &&
                        <>
                            <div className="bg-light-grey d-flex flex-column border-12 p-3 mt-3 justify-content-center align-items-center w-100">
                                <p className="bold">{t("extended_info.no_scheduled_payments")}</p>
                                <p className="dark-grey">{t("extended_info.next_payment")}</p>
                            </div>
                            <NewButton onClick={() => goTo("subscriptions")} className="bg-gradient p-3 rounded12 w-100 white-white mt-3 body bold">{t("extended_info.activate_dataplan")}</NewButton>
                        </>
                        }
                        {active_plan &&
                            <div className="d-flex flex-row justify-content-around align-items-center mt-3 w-100">
                                <div className="detail_container bg-light-grey d-flex flex-column border-12 p-3 align-items-center w-50 me-2">
                                    <p className="bold">{fixDate(subscription?.dataplan?.duration_end, true)}</p>
                                    <p className="dark-grey">{no_recurring ? t("extended_info.subscription_ends") : t("extended_info.next_payment")}</p>
                                </div>
                                <div className="detail_container bg-light-grey d-flex flex-column border-12 p-3 align-items-center w-50 ms-2">
                                    <p className="bold">{no_recurring ? t("extended_info.cancelled") : subscription?.dataplan_active ? t("devices.on") : t("devices.off")}</p>
                                    <p className="dark-grey">{t("extended_info.status")}</p>
                                </div>
                            </div>
                        }
                        {/* <div className="detail_container bg-light-grey d-flex flex-column border-12 p-3 align-items-center w-100 mt-3">
                            <p className="bold">{"Boost"}</p>
                            <p className="thin dark-grey">{t("extended_info.region_coverage")}</p>
                        </div> */}
                    </div>
                </div>

            </div>
        )
    }

    const stolenModeModal = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t(`extended_info.${info.title}`)}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
                </div>
                <div className="d-flex flex-column">
                    <p className="grey-blue py-3">{t(`extended_info.${info.copy}`)}</p>
                    <form>
                        <div className="form-group d-flex align-items-center position-relative rounded24 bg-light-grey">
                            <input
                                type={"text"}
                                className="form-control rounded24 p-3 bg-light-grey grey-blue pe-5"
                                id="text"
                                value={data?.url ?? ""}
                                placeholder=""
                                readOnly={true}
                            />
                            <img src={copySuccess ? icons.radio_checked : icons.copy} onClick={() => copyLink(data?.url)} className={`${copySuccess ? "": "inp-link-icon"} position-absolute size_15 ms-2 cursor-pointer end-0 me-2`} alt="" />
                        </div>
                    </form>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => turnOffStolenMode("")} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">{t("extended_info.turn_off")}</NewButton>
                </div>
            </div>
        )
    }

    const typeRender = () => {
        switch(type){
            case "temp":
                setModalType("graph")
                setInfo({title: "temp_title", copy: "temp_copy", icon: icons.temperature})
            break;
            case "humidity":
                setModalType("graph")
                setInfo({title: "hum_title", copy: "hum_copy", icon: icons.humidity})
            break;
            case "battery":
                setModalType("graph")
                setInfo({title: "battery_title", copy: "battery_copy", rotate: true, icon: icons.battery_three_quarter})
            break;
            case "voltage":
                setModalType("graph")
                setInfo({title: "voltage_title", copy: "voltage_copy", icon: icons.volt})
            break;
            case "dataplan":
                setModalType("dataplan")
                setInfo({title: "dataplan_title", copy: "dataplan_copy", icon: icons.sidebar.card_active})
            break;
            case "stolenmode":
                setModalType("stolenmode")
                setInfo({title: "stolenmode_title", copy: "stolenmode_copy", icon: icons.stolenmode})
            break;
            default: return null
        }
    }
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100 grey-blue">
                    {modalType === "graph" && data
                        ? graphModal()
                    : modalType === "dataplan" && data
                        ? dataplanModal()
                    : modalType === "stolenmode" && data
                        ? stolenModeModal()
                    : null
                    }
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default ExtendedInfoModal;